/**
 * Adhoc Points API Endpoints
 * Framework-agnostic endpoint definitions for adhoc points module
 * All endpoints require program_id query parameter
 */

export const ADHOC_ENDPOINTS = {
  /** Get list of all adhoc points requests */
  list: 'adhoc/list-adhoc-points',

  /** Upload and validate adhoc points request with Excel and proof */
  uploadValidate: 'adhoc-points/upload-validate',

  /** Approve adhoc points request (async job) */
  approve: 'adhoc/approve-adhoc-points-async',

  /** Get user types for enrollment */
  getUserTypes: 'enrollment-onboarding/get-user-types',

  /** Get user groups for a role: user-group/list-user-groups-by-role?role_id= */
  getUserGroups: 'user-group/list-user-groups-by-role',

  /** Get selected modules by user group */
  getModulesByUserGroup: 'earning-user-group-setting/get-selected-modules-by-user-group',

  /** Get module items by module code (targets, schemes, etc.) */
  getModuleItems: 'earning-user-group-setting/get-list-module-config',

  /** Get upload history - queue file progress status */
  getUploadHistory: 'queue/file-progress-status-module-wise',

  /** Get gap analysis for a job */
  getGapAnalysis: 'adhoc-points/gap-analysis',

  /** Import validated adhoc points data */
  importValidated: 'adhoc-points/import',

  /** Reject job */
  rejectJob: 'queue-job/user-reject',
} as const;
